const taxAssumptionEditor = (baseApiUrl) => {
    // Check for both person and company sections
    const personSection = document.querySelector('#person')
    const companySection = document.querySelector('#info')
    const targetSection = personSection || companySection
    if (!targetSection) return
    
    // Extract contactId from current URL (both person and company)
    const personMatch = window.location.pathname.match(/\/edit-person\/(\d+)/)
    const companyMatch = window.location.pathname.match(/\/edit-company\/(\d+)/)
    const contactId = (personMatch ? personMatch[1] : null) || (companyMatch ? companyMatch[1] : null)
    if (!contactId) return
    
    // Check if element exists for different contact - remove and recreate.
    // Also recreate when lux-pickers are missing (stale shell after failed/old inject).
    const existingSection = document.querySelector('#tax-assumption')
    if (existingSection) {
        const hasLuxPickers =
            existingSection.querySelectorAll(
                '.tax-from-picker-container .lux-picker, .tax-to-picker-container .lux-picker',
            ).length >= 2
        if (existingSection._contactId === contactId && hasLuxPickers) return
        existingSection.remove()
    }

    const subSection = document.createElement('div')
    subSection.className = 'sub-section'
    subSection.id = 'tax-assumption'
    subSection._contactId = contactId
    subSection.innerHTML = `
        <div class="sub-section-header">
            <div class="sub-section-title" style="display:flex;align-items:center;width:100%;">
                <span>Freistellungsbescheinigung</span>
                        <style>
                .spinner {
                    border: 4px solid rgba(0, 0, 0, 0.1);
                    width: 22px;
                    height: 22px;
                    border-radius: 50%;
                    border-left-color: black;
                    margin: 10px auto;
                    margin-left:20px;
                    animation: spin 1s ease infinite;
                }
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                .tax-delete-btn {
                    background: #ff4d4f;
                    color: white;
                    border: none;
                    padding: 4px 12px;
                    border-radius: 4px;
                    cursor: pointer;
                    font-size: 13px;
                    display: none;
                    margin-left: auto;
                }
                .tax-delete-btn:hover:not(:disabled) {
                    background: #ff7875;
                }
                .tax-delete-btn:disabled {
                    background: #d9d9d9;
                    cursor: not-allowed;
                }
                input[name="taxAssumptionFile"] {
                    position: absolute;
                    width: 0.1px;
                    height: 0.1px;
                    opacity: 0;
                    overflow: hidden;
                    z-index: -1;
                }
            </style>
            <div class="spinner"></div>
                <button class="tax-delete-btn" type="button">Löschen</button>
            </div>
        </div>
        <div class="sub-section-content">
            <div class="sub-section-content-row">
                <div class="sub-section-content-column" style="min-width: 25rem;">
                    <div class="DateInput">
                        <div class="ant-row ant-form-item" style="row-gap: 0px;">
                            <div class="ant-col ant-form-item-label"><label><span>Gültig Von *</span></label></div>
                            <div class="ant-col ant-form-item-control">
                                <div class="tax-from-picker-container"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sub-section-content-column" style="min-width: 25rem;">
                    <div class="DateInput">
                        <div class="ant-row ant-form-item" style="row-gap: 0px;">
                            <div class="ant-col ant-form-item-label"><label><span>Gültig Bis *</span></label></div>
                            <div class="ant-col ant-form-item-control">
                                <div class="tax-to-picker-container"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sub-section-content-row">
                <div class="sub-section-content-column" style="min-width: 25rem;">
                    <div class="TextInput">
                        <div class="ant-row ant-form-item" style="row-gap: 0px;">
                            <div class="ant-col ant-form-item-label"><label><span>Dokument (PDF) *</span></label></div>
                            <div class="ant-col ant-form-item-control">
                                <div class="tax-file-picker-container"></div>
                                <div class="tax-file-info" style="font-size:12px;color:#666;margin-top:4px;"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sub-section-content-column" style="min-width: 25rem;"></div>
            </div>
            <div class="sub-section-content-row tax-history-container" style="display:none;">
                <div class="sub-section-content-column" style="width:100%;">
                    <div class="tax-history-toggle" style="cursor:pointer;display:flex;align-items:center;gap:8px;padding:8px 0;color:gray;">
                        <span class="tax-history-arrow" style="transition:transform 0.2s;">▶</span>
                        <span>Änderungsverlauf anzeigen</span>
                    </div>
                    <div class="tax-history-content" style="display:none;padding:8px 0;border-top:1px solid #e8e8e8;margin-top:8px;">
                        <div class="tax-history-list" style="font-size:13px;"></div>
                    </div>
                </div>
            </div>
        </div>
    `

    targetSection.parentNode.insertBefore(subSection, targetSection.nextSibling)

    const loadingSpinner = subSection.querySelector('.spinner')
    
    // Initialize lux-picker date fields (Gültig Von / Gültig Bis)
    const fromPickerContainer = subSection.querySelector('.tax-from-picker-container')
    const toPickerContainer = subSection.querySelector('.tax-to-picker-container')
    const fromInput = datePicker('taxAssumptionFrom')
    const toInput = datePicker('taxAssumptionTo')
    fromInput.setDisabled(false)
    toInput.setDisabled(false)
    fromPickerContainer.replaceChildren(fromInput.wrapper)
    toPickerContainer.replaceChildren(toInput.wrapper)
    
    // Initialize file picker component
    let selectedFile = null
    const filePickerContainer = subSection.querySelector('.tax-file-picker-container')
    const filePickerInstance = filePicker({
        name: 'taxAssumptionFile',
        id: 'taxAssumptionFile',
        accept: '.pdf',
        disabled: true,
        placeholder: 'Datei auswählen',
        validateFile: (file) => {
            if (file && file.type !== 'application/pdf') {
                return 'Nur PDF-Dateien erlaubt'
            }
            return true
        },
        onFileChange: (file) => {
            selectedFile = file
        }
    })
    filePickerContainer.appendChild(filePickerInstance.wrapper)
    
    const fileInfoDiv = subSection.querySelector('.tax-file-info')
    const historyContainer = subSection.querySelector('.tax-history-container')
    const historyToggle = subSection.querySelector('.tax-history-toggle')
    const historyArrow = subSection.querySelector('.tax-history-arrow')
    const historyContent = subSection.querySelector('.tax-history-content')
    const historyList = subSection.querySelector('.tax-history-list')
    const deleteBtn = subSection.querySelector('.tax-delete-btn')

    // Helper to disable/enable all inputs and buttons
    const setFormDisabled = (disabled) => {
        fromInput.setDisabled(disabled)
        toInput.setDisabled(disabled)
        filePickerInstance.setDisabled(disabled)
        deleteBtn.disabled = disabled
        loadingSpinner.style.display = disabled ? 'block' : 'none'
    }

    // Setup history toggle
    historyToggle.addEventListener('click', () => {
        const isOpen = historyContent.style.display !== 'none'
        historyContent.style.display = isOpen ? 'none' : 'block'
        historyArrow.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(90deg)'
    })

    const getToken = () => JSON.parse(localStorage.getItem('auth') || '{}').token

    let existingTaxExemption = null
    let isSaving = false

    // Reset form to initial state
    const resetForm = () => {
        existingTaxExemption = null
        selectedFile = null
        isSaving = false
        fromInput.setValue('')
        toInput.setValue('')
        filePickerInstance.reset()
        fileInfoDiv.innerHTML = ''
        historyContainer.style.display = 'none'
        historyList.innerHTML = ''
        historyContent.style.display = 'none'
        historyArrow.style.transform = 'rotate(0deg)'
        deleteBtn.style.display = 'none'
    }

    // Delete tax exemption
    const deleteTaxExemption = async () => {
        if (!existingTaxExemption?.id) return
        
        if (!confirm('Möchten Sie den Freistellungsbescheinigung wirklich löschen?')) return

        const token = getToken()
        if (!token) return

        isSaving = true
        setFormDisabled(true)

        try {
            const res = await fetch(`${baseApiUrl}/api/impowerX/contacts/tax-exemption/contact/${contactId}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            })
            if (!res.ok) throw new Error('Delete failed')
            resetForm()
        } catch (err) {
            console.error('Delete tax exemption error:', err)
            alert('Fehler beim Löschen des Freistellungsbescheinigung')
        } finally {
            isSaving = false
            setFormDisabled(false)
        }
    }

    deleteBtn.addEventListener('click', deleteTaxExemption)

    // Format date to YYYY-MM-DD for lux-picker setValue
    const formatDateForInput = (dateString) => {
        if (!dateString) return ''
        const date = new Date(dateString)
        return date.toISOString().split('T')[0]
    }

    // Fetch document details by ID
    const fetchDocumentDetails = async (token, documentId) => {
        try {
            const res = await fetch(`/services/pmp-document/api/v1/documents/${documentId}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            })
            if (res.ok) {
                return await res.json()
            }
        } catch (e) { console.error('Fetch document details error:', e) }
        return null
    }

    // Load existing data
    const load = async () => {
        const token = getToken()
        if (!token) return
        try {
            const res = await fetch(`${baseApiUrl}/api/impowerX/contacts/tax-exemption/contact/${contactId}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            })
            if (res.ok) {
                const data = await res.json()
                existingTaxExemption = data.taxExemption

                if (existingTaxExemption?.validityFrom) {
                    fromInput.setValue(formatDateForInput(existingTaxExemption.validityFrom))
                }
                if (existingTaxExemption?.validityTo) {
                    toInput.setValue(formatDateForInput(existingTaxExemption.validityTo))
                }
                if (existingTaxExemption?.document_id) {
                    const docDetails = await fetchDocumentDetails(token, existingTaxExemption.document_id)
                    if (docDetails) {
                        const fileLink=createAttachmentItem(docDetails.name,()=>downloadDocument(token))
                        fileInfoDiv.appendChild(fileLink)
                    } else {
                        fileInfoDiv.textContent = 'Dokument vorhanden'
                    }
                }
                // Show delete button if tax exemption exists
                if (existingTaxExemption?.id) {
                    deleteBtn.style.display = 'block'
                }

                // Show history if available
                if (existingTaxExemption?.history && existingTaxExemption.history.length > 0) {
                    historyContainer.style.display = 'block'
                    historyList.innerHTML = existingTaxExemption.history
                        .slice()
                        .reverse()
                        .map(entry => {
                            const date = new Date(entry.timestamp)
                            const formattedDate = date.toLocaleDateString('de-DE', { 
                                day: '2-digit', month: '2-digit', year: 'numeric', 
                                hour: '2-digit', minute: '2-digit' 
                            })
                            const actionTextMap = {
                                'created': 'Erstellt',
                                'updated': 'Bearbeitet',
                                'deleted': 'Gelöscht',
                                'restored': 'Wiederhergestellt'
                            }
                            const actionText = actionTextMap[entry.action] || entry.action
                            return `<div style="padding:4px 0;border-bottom:1px solid #f0f0f0;">
                                <span style="color:#666;">${formattedDate}</span> - 
                                <strong>${entry.userName}</strong> 
                                <span style="color:#888; margin-right:1rem">(${actionText})</span>
                                ${entry.changes ? (() => {
                                    const changes = [];
                                    if (entry.changes.validityFrom) {
                                        changes.push(`Gültig von: ${new Date(entry.changes.validityFrom).toLocaleDateString('de-DE')}`);
                                    }
                                    if (entry.changes.validityTo) {
                                        changes.push(`Gültig bis: ${new Date(entry.changes.validityTo).toLocaleDateString('de-DE')}`);
                                    }
                                    if (entry.changes.documentId) {
                                        changes.push('Dokument geändert');
                                    }
                                    return changes.length ? `<span style="color:#1890ff; font-size:12px;">${changes.join('&nbsp;,&nbsp;&nbsp;')}</span>` : '';
                                })() : ''}
                            </div>`
                        })
                        .join('')
                }
            }
        } catch (e) { console.error('Load tax exemption error:', e) }
        finally{
            setFormDisabled(false)
        }
    }
    setTimeout(load, 500)

    // Upload document
    const uploadDocument = async (token, file) => {
        const formData = new FormData()
        formData.append('file', file)
        const queryParams = `?contactId=${contactId}&name=Freistellungsbescheinigung_${new Date().getTime()}`
        const res = await fetch(`/services/pmp-document/api/v1/documents/upload${queryParams}`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` },
            body: formData
        })
        if (!res.ok) throw new Error('Document upload failed')
        return await res.json()
    }
    const downloadDocument = async (token) => {
        try {
            const res = await fetch(`/services/pmp-document/api/v1/documents/${existingTaxExemption.document_id}/download`, {
                method: 'GET',
                headers: { 'Authorization': `Bearer ${token}` },
            })
            if (!res.ok) {
                alert('Fehler beim Herunterladen des Dokuments')
                return
            }
            const blob = await res.blob()
            const blobUrl = URL.createObjectURL(blob)
            window.open(blobUrl, '_blank')
        } catch (e) {
            console.error('Download document error:', e)
            alert('Fehler beim Herunterladen des Dokuments')
        }
    }

    // Save tax exemption
    const saveTaxExemption = async (token, documentId) => {
        const res = await fetch(`${baseApiUrl}/api/impowerX/contacts/tax-exemption/contact/${contactId}`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify({
                validityFrom: fromInput.getValue(),
                validityTo: toInput.getValue(),
                documentId
            })
        })
        if (res.ok) {
            const data = await res.json()
            return data.taxExemption
        }
        throw new Error('Save failed')
    }
    const handleCLick= async (e) => {
        // Prevent double-submission
        if (isSaving) return
        const {document_id ,id , validityFrom ,validityTo} = existingTaxExemption || {}
        const fromValue = fromInput.getValue()
        const toValue = toInput.getValue()
        const hasFrom = !!fromValue
        const hasTo = !!toValue
        const hasFile = !!selectedFile || !!document_id
        const allFieldsEmpty = !hasFrom && !hasTo && !hasFile

        // If nothing to edit and No data to create, ignore
        if (!id && allFieldsEmpty) return;


        // Validate all fields if any is filled
        if (!hasFrom || !hasTo || !hasFile) {
            e.preventDefault()
            e.stopPropagation()
            alert('Freistellungsbescheinigung: Alle Felder sind Pflichtfelder (Von, Bis, Dokument)')
            return
        }
        //nothing changed Per edit
        if(id 
            && formatDateForInput(validityFrom) === fromValue
            && formatDateForInput(validityTo) === toValue
            && !selectedFile 
        ) return;

        const token = getToken()
        if (!token) return

        isSaving = true
        setFormDisabled(true)
        try {
            let documentId = existingTaxExemption?.document_id
            if (selectedFile) {
                const uploadRes = await uploadDocument(token, selectedFile)
                documentId = uploadRes.id
            }
            const savedData = await saveTaxExemption(token, documentId)
            existingTaxExemption = savedData  // Update cached data to prevent false change detection
            selectedFile = null  // Clear selected file after successful save
            // Show delete button after successful save
            if (existingTaxExemption?.id) {
                deleteBtn.style.display = 'block'
            }
        } catch (err) {
            console.error('Save tax exemption error:', err)
            alert('Fehler beim Speichern des Freistellungsbescheinigung')
        } finally {
            isSaving = false
            setFormDisabled(false)
        }
    }
    const saveBtn = document.querySelector('button.ant-btn-primary.save')
    const saveSectionBtn = document.querySelector('.FormSection#ContactData .Button.section-submit')
    if (saveBtn)  saveBtn.addEventListener('click', handleCLick)
    if(saveSectionBtn) saveSectionBtn.addEventListener('click',handleCLick)
}

function createAttachmentItem(name,download) {
    var attachmentItem = document.createElement('div')
    attachmentItem.style.display = 'flex'
    attachmentItem.style.alignItems = 'center'
    
    var attachmentLink = document.createElement('a')
    attachmentLink.addEventListener('click',download)
    
    // Create inline SVG for document icon
    var attachmentIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    attachmentIcon.setAttribute('width', '15')
    attachmentIcon.setAttribute('height', '15')
    attachmentIcon.setAttribute('viewBox', '0 0 24 24')
    attachmentIcon.setAttribute('fill', 'none')
    attachmentIcon.setAttribute('stroke', 'currentColor')
    attachmentIcon.setAttribute('stroke-width', '2')
    attachmentIcon.setAttribute('stroke-linecap', 'round')
    attachmentIcon.setAttribute('stroke-linejoin', 'round')
    attachmentIcon.style.marginRight = '8px'
    attachmentIcon.style.flexShrink = '0'
    attachmentIcon.style.color = '#666'
    attachmentIcon.innerHTML = '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline>'

    attachmentLink.style.textDecoration = 'none'
    attachmentLink.style.color = '#333'
    attachmentLink.style.cursor = 'pointer'
    attachmentLink.textContent = name

    attachmentItem.appendChild(attachmentIcon)
    attachmentItem.appendChild(attachmentLink)
    return attachmentItem
  }